<template>
  <div class="FreeMemberRemoval2">
    <section-header heading="2" ja="無料会員削除の再確認" />
    <div class="description">
      {{ description }}
    </div>
    <div class="home-button">
      <normal-btn @click="onHome">引き続き利用する</normal-btn>
    </div>
    <div class="removal-button">
      <normal-btn @click="onRemoval">削除する</normal-btn>
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"
import NormalBtn from '../components/NormalBtn.vue'
import Protobuf from "../mixins/protobuf"

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "FreeMemberRemoval2",
  components: {
    SectionHeader,
    NormalBtn
  },
  mixins: [Protobuf],
  data() {
    return {
      description: '\n' +
        '無料会員を削除すると、ダウンロードしたすべての画像が削除されます。\n' +
        '※一度削除された画像は戻すことができません。\n' +
        '本当に無料会員登録を削除しますか？'
    }
  },
  methods: {
    onHome() {
      this.$router.push('/')
    },
    onRemoval() {
      const cmdNo = pb.PlayerUnsubscribeReq.CommandNo.COMMAND_NO
      const message = pb.PlayerUnsubscribeReq.create()
      const encoded = pb.PlayerUnsubscribeReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.PlayerUnsubscribeResp.Status.SUCCESS) {
            this.$store.dispatch('logout')
            this.$store.dispatch('saveMembershipGrade', decoded.membershipGrade)
            this.$router.push('/freeMemberRemovalFinish')
          } else {
            this.$_error('Error', { title: '無料会員削除', statusCode: 408 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: '無料会員削除', statusCode: 100 })
        })
    }
  },
  mounted() {
    if (this.$store.getters.isFreeMembership) {
      return
    }
    //TODO: 有料会員だったときに無料会員解除ページへ遷移した場合は、先に有料会員の解約を行う旨の表示を行う
    this.$_error('Error', { title: '無料会員削除', statusCode: 100 })
  }
}
</script>

<style scoped>
.description {
  color: #5e5e5e;
  font-size: 12px;
  margin: 20px auto 40px auto;
  white-space: pre-wrap;
  max-width: 90%;
}
.home-button {
  margin: 40px 0px 30px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.removal-button {
  margin: 30px 0px 60px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
